import { z } from 'zod';

import { SectionDtoScheme } from '~modules/section/model';
import { UserDtoScheme } from '~modules/user/model';

export const RoleDtoSchema = z.object({
	user_id: z.number().describe('Идентификатор пользователя'),
	section_id: z.number().describe('Идентфикатор участка'),
	name: z.string().describe('Наименование роли'),

	user: UserDtoScheme.describe('Пользователь').nullable().optional(),
	section: SectionDtoScheme.describe('Участок').nullable().optional(),
});

export type RoleDto = z.infer<typeof RoleDtoSchema>;
